/**
 * iosHoverFix.js
 * File for fixing the hover bug in iOS mobile devices
 */
/**
 * iOS hover fix
 */
document.addEventListener("touchstart", function() {}, false);
